import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TranslationCommunicationServiceService {
  private selectedLanguageSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>(
      localStorage.getItem('selectedLanguage') || 'en'
    );
  constructor() {}

  public setSelectedLanguage(language: string): void {
    localStorage.setItem('selectedLanguage', language);
    this.selectedLanguageSubject.next(language);
  }

  public getSelectedLanguage(): Observable<string> {
    return this.selectedLanguageSubject.asObservable();
  }
}
